import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ImpactPage from './pages/ImpactPage';
import LightImpactPage from "./pages/LightImpactPage";
import AboutPage from "./pages/AboutPage";
import ScoutPage from "./pages/ScoutPage";
import ExperimentalPage from "./pages/ExperimentalPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impact-light/:summonerName/:tag" element={<LightImpactPage />} />
        <Route path="/impact/:summonerName/:tag" element={<ImpactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/scout" element={<ScoutPage />} />
        <Route path="/scout/shared/:shareId" element={<ScoutPage />} />
        <Route path="/experimental" element={<ExperimentalPage />} />
      </Routes>
    </Router>
  );
}

export default App;
